import {Injectable} from '@angular/core';
import {ChangelogPopupComponent} from '../../editor-interface/dialogs/changelog-popup/changelog-popup.component';
import {PopupManagerService} from './popup-manager.service';
import {RequestsService} from '../requests/requests.service';
import {DiagramJsonHandlerService} from '../../diagram-data/diagram-json-handler.service';
import {ActivatedRoute} from '@angular/router';
import {HttpParams} from '@angular/common/http';
import {BehaviorSubject, from, Observable, of} from 'rxjs';
import {environment} from '../../../environments/environment';
import {CustomEncoder} from '../helpers/custom-encoder';
import {TranslateService} from '@ngx-translate/core';
import {catchError, tap} from 'rxjs/operators';
import {DialogWidth} from '@q9elements/ui-kit/common';

@Injectable({
  providedIn: 'root'
})
export class ChangelogsService {
  public manual = false;
  public agentforce = false;
  public changelogsSubject: BehaviorSubject<any> = new BehaviorSubject({});
  public changelogs$: Observable<any> = this.changelogsSubject.asObservable();

  constructor(
    private popupSvc: PopupManagerService,
    private translateSvc: TranslateService,
    private requestsSvc: RequestsService,
    private route: ActivatedRoute,
    private diagramJsonSvc: DiagramJsonHandlerService
  ) {}

  public openChangelogPopUp() {
    this.popupSvc.open(ChangelogPopupComponent, {
      panelClass: ['q9-dialog'],
      width: DialogWidth.MD
    });
  }

  public getChangelogs(diagramId?: string): Observable<any> {
    if (this.diagramJsonSvc.isPro() || this.diagramJsonSvc.isFree() || diagramId) {
      return from(this.requestsSvc.addToQueue(this.taskForChangelogs(diagramId), true)).pipe(
        tap(result => this.changelogsSubject.next(result)),
        catchError(error => {
          this.changelogsSubject.next(error);

          return of(null);
        })
      );
    }

    return of({});
  }

  public callAutoLog(diagramId: string) {
    return this.requestsSvc.addToQueue(this.taskForAutoLog(diagramId), false);
  }

  public taskForAutoLog(id: string) {
    return {
      isApi: true,
      url: `/diagram/${id}/state/draft/log`,
      method: 'PUT',
      data: {manual: false}
    };
  }

  public taskForChangelogs(diagramId: string) {
    let params;

    if (this.manual) {
      params = new HttpParams({
        fromString: `addThumbs=${true}&limit=${10}&manual=${this.manual}`,
        encoder: new CustomEncoder()
      });
    } else if (this.agentforce) {
      params = new HttpParams({
        fromString: `addThumbs=${true}&limit=${10}&agentforce=${this.agentforce}`,
        encoder: new CustomEncoder()
      });
    } else {
      params = new HttpParams({
        fromString: `addThumbs=${true}&limit=${10}`,
        encoder: new CustomEncoder()
      });
    }

    const id = diagramId ? diagramId : this.diagramJsonSvc.get().diagramId;
    const url = `/diagram/${id}/state/draft/log/list`;

    return {
      isApi: true,
      url: url,
      method: 'GET',
      queryParams: params
    };
  }

  public navigateToTheChangeLogInAnotherTab(seqNum: string | number) {
    const seqNumStr = seqNum ? '?seqNum=' + seqNum : '';

    window.open(
      environment.CHANGELOG_APP_URL +
        '/diagram/' +
        this.diagramJsonSvc.get().diagramId +
        '/logs' +
        seqNumStr,
      '_blank'
    );
  }
}
